import { api } from "~/api";

export enum ToastTypeTag {
  TELEGRAM_CHANNEL = "TELEGRAM_CHANNEL",
  EVENT_INVITATION_I_AM_DOCTOR = "EVENT_INVITATION_I_AM_DOCTOR",
  PRICE_LIST_UPDATE_JUNE_2025 = "PRICE_LIST_UPDATE_JUNE_2025",
  PULSE_SURVEY_2025 = "PULSE_SURVEY_2025",
  REDESIGN_V1_WELCOME = "REDESIGN_V1_WELCOME",
}

export enum ToastCloseIntent {
  ACTION = "action",
  CLOSE = "close",
}

const extendedApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getToasts: builder.query<ToastTypeTag[], void>({
      query: () => ({ url: "toasts" }),
      providesTags: ["Toast"],
    }),
    closeToast: builder.mutation<void, { tag: ToastTypeTag; intent?: ToastCloseIntent }>({
      query: (data) => ({ url: "toasts", method: "POST", body: data }),
      invalidatesTags: ["Toast"],
    }),
  }),
});

export const { useGetToastsQuery, useCloseToastMutation } = extendedApi;
